function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "../Text";
import { View } from "../View";
var colorGroups = [
    [
        '#F8E9E9',
        '#AE595B'
    ],
    [
        '#EEE8EE',
        '#8B688D'
    ],
    [
        '#D9EDED',
        '#008689'
    ],
    [
        '#FFF5D4',
        '#A88207'
    ]
];
function getColorForName(name) {
    if (!name.length) return colorGroups[0];
    var value = name.split('').reduce(function(carry, el) {
        return carry + el.toUpperCase().charCodeAt(0);
    }, 0);
    return colorGroups[value % colorGroups.length];
}
var getInitials = function(name) {
    var firstLetters = name.match(/\b\w/g) || [];
    return ((firstLetters.shift() || '') + (firstLetters.pop() || '')).toUpperCase();
};
/**
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃́̀̀̃̀̀̀̃̀̀̀̂̌̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̃̀̀̆̅̀̀̆̎̀̀̇̄̀̀̆̅̀̀̇̂̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̅̀̀̃́̀̀̃̂̀̀̆̅̀̀̆̅̀̀̃́̀̀̃̉̀̀̃̀̀̀̂̍̀̀̃̀̀̀̃̂̀̀̃̅̀̀̆̅̀̀̂̍̀̀̃̄̀̀̃̃̀̀̆̂̀̀̆̄̀̀̂̍̀̀̃̉̀̀̃̂̀̀̆̅̀̀̆̃̀̀̂̍̀̀̃̃̀̀̆̆̀̀̃̂̀̀̃̂̀̀̃̉̀̀̃̄̀̀̃̉̀̀̃̂̀̀̆̆̀̀̃̅̀̀̃̄̀̀̃̈̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̇̀̀̃̀̀̀̃̉̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̉̀̀̃̄̀̀̃̄̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-3}
 */ export var Avatar = function(param) {
    var name = param.name, _param_round = param.round, round = _param_round === void 0 ? true : _param_round, _param_size = param.size, size = _param_size === void 0 ? 25 : _param_size;
    var initials = getInitials(name);
    var _getColorForName = _sliced_to_array(getColorForName(name), 2), backgroundColor = _getColorForName[0], color = _getColorForName[1];
    return /*#__PURE__*/ _jsx(View, {
        "aria-label": "User Avatar for ".concat(name),
        testID: "Avatar_".concat(initials),
        style: {
            width: size,
            height: size,
            backgroundColor: backgroundColor,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: round ? size / 2 : 0
        },
        children: /*#__PURE__*/ _jsx(Text, {
            color: color,
            weight: "bold",
            size: size / 2.2,
            text: initials
        })
    });
};
